export const NOTICE_SHOW = {
  name: '首页商场公告展示',
	api: '${ZUKER}/ma-tenant/tenant/D/notice/noticeShow',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#/%E5%95%86%E6%88%B7%E9%80%9A%E5%BA%94%E7%94%A8API/%E5%95%86%E5%9C%BA%E5%85%AC%E5%91%8AD%E7%AB%AF%E6%8E%A5%E5%8F%A3/noticeShowUsingPOST',
}
export const NOTICE_LIST = {
  name: '首页商场公告列表',
	api: '${ZUKER}/ma-tenant/tenant/D/notice/list',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#/%E5%95%86%E6%88%B7%E9%80%9A%E5%BA%94%E7%94%A8API/%E5%95%86%E5%9C%BA%E5%85%AC%E5%91%8AD%E7%AB%AF%E6%8E%A5%E5%8F%A3/noticeShowUsingPOST',
}